module.exports = __webpack_public_path__ + "img/07.233a3361.jpeg";